export default __webpack_public_path__ + "static/latitude-gem-card-bolder-8c5657fb39877a72df3ae2ba478d9d01.webp";